import { gql } from 'graphql-tag';

const getDetalleEvaluacionVarTemp = gql`
  query Query($idEvaluacion: Int!, $idVarTemp: String!, $idVarTemp2: String!, $idVarTemp3: String!) {
    valor1:
      detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp) {
        idEvaluacion
        idVarTemp
        valor
      }
    valor2:
      detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp2) {
        idEvaluacion
        idVarTemp
        valor
      }
    valor3:
      detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp3) {
        idEvaluacion
        idVarTemp
        valor
      }
  }
`;

export { getDetalleEvaluacionVarTemp };